import React from 'react';
import styled from 'styled-components';
import { getTranslatedString } from 'helpers/i18n';
import { Radio } from 'antd';
import { media } from 'helpers/MediaHelper';

const StyledRadioGroupContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  margin: 10px 0px;
  align-items: center;
  ${media.mobile`
    flex-direction: column;
    align-items: start;
  `};
`;

const StyledAntdRadioGroup = styled(Radio.Group)`
  ${media.mobile`
    margin-top: 10px;
    width:100%;
  `};
`;

const StyledRadio = styled(Radio)`
  margin-right: ${props => (props.value ? '40px' : '0px')};
  ${media.mobile`
    margin-right: 0;
  `};
  ${props => props.isMobile && `display: flex`};
  ${props => props.isMobile && `flex-direction: row-reverse`};
`;

const StyledRadioGroup = styled.div`
  padding-left: 20px;
  ${media.mobile`
    padding-left: 0;
    display:flex;
    justify-content: space-between;
  `};
`;

const RadioGroup = ({ onChange, label, disabled, value, customOptions, children }) => {
  const isMobile = window.matchMedia('(max-width: 750px)').matches;

  const handleChange = e => {
    onChange(e.target.value);
  };

  return (
    <StyledRadioGroupContainer>
      {label}
      {children}
      <StyledAntdRadioGroup value={value} onChange={handleChange} disabled={disabled}>
        {customOptions ? (
          <StyledRadioGroup>
            {customOptions.map((option, index) => (
              <StyledRadio value={option.value} isMobile={isMobile && index === 1}>
                {option.label}
              </StyledRadio>
            ))}
          </StyledRadioGroup>
        ) : (
          <StyledRadioGroup>
            <StyledRadio value={true}>{getTranslatedString('yes')}</StyledRadio>
            <StyledRadio value={false} isMobile={isMobile}>
              {getTranslatedString('no')}
            </StyledRadio>
          </StyledRadioGroup>
        )}
      </StyledAntdRadioGroup>
    </StyledRadioGroupContainer>
  );
};

export default RadioGroup;
